import { ActorChallengeRecommendation } from '@/Domain/Challenge/Types/challenge-types'

export const transformChallengeActorRecommendationsToChallengeActorArray = (apiResponse: any[]): ActorChallengeRecommendation[] => {
  return apiResponse
    .map((challengeActor: any) => {
      return {
        sqlId: challengeActor.sql_id,
        id: challengeActor.id,
        name: challengeActor.name,
        description: challengeActor.description || challengeActor.short_description || '',
        shortDescription: challengeActor.short_description || '',
        actorType: challengeActor.actor_type,
        url: challengeActor.url || '',
        websiteScreenshot: challengeActor.website_screenshot || '',
        logo: challengeActor.logo || '',
        hasInviteesAttached: challengeActor.has_invitees_attached > 0,
        isActorShortListed: challengeActor.is_actor_short_listed,
        isActorClaimed: challengeActor.is_actor_claimed,
        suggestedThroughAgenticMatchMaking: challengeActor.suggested_through_agentic_match_making,
        address: challengeActor.address,
        founding_date: challengeActor.founding_date,
      }
    })
}

export const transformChallengeShortListedActorsToChallengeActorArray = (apiResponse: any[]): ActorChallengeRecommendation[] => {
  return transformChallengeActorRecommendationsToChallengeActorArray(apiResponse)
}
